// extracted by mini-css-extract-plugin
export default {"addFeed":"styles_addFeed__ZwWWO","container":"styles_container__IdmYj"};